import { deleteApi, get, post } from "../GenericServices";

const WorkPackage = {
  projectEstimateWorkPackageDetails: (id) => {
    return get(`work-package/${id}`);
  },
  workPackageList: (querystring) => {
    return get(`work-package?${querystring}`);
  },
  projectEstimateWorkPackageSave: (data) => {
    return post(`work-package`, data);
  },
  projectEstimateWorkPackageDelete: (id) => {
    return deleteApi(`work-package/${id}`);
  },
};

export default WorkPackage;
